import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/sobre",
    name: "sobre",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import("../views/ContactView.vue"),
  },
  {
    path: "/metodologia",
    name: "methodology",
    component: () =>
      import("../views/MethodologyView.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
